import React, { useRef, useState } from "react";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import EventIcon from "@mui/icons-material/Event";
import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

import "react-datepicker/dist/react-datepicker.css";

import { useEffect } from "react";

import {
  getEndOfMonth,
  getFirstDateOfCurrentMonthPayloadFormate,
  getFirstDateOfMonth,
  getLastDateOfCurrentMonthPayloadFormat,
  getStartOfMonth,
  payloadDateFormat,
} from "../../../utils/commonUtils";
import GstReportCard from "../gstReport/gstReportCard";
import { getMonthlyDetails } from "../cashCounterSale/reportsApi";
import { getAppoinment, getAppointmentXlsx } from "./api";
import CardPayment from "../../payment/cardPayment";
import axios from "../../../utils/axios";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CounterSalesItemCard from "../totalCounterSaleReport.jsx/counterItemCard";
import Heading from "../../../common/Heading";

const AppoinmentReport = () => {
  const [open, setOpen] = useState(false);
  const datePickerRef2 = useRef();
  const [counterSales, setCounterSales] = useState();

  //------------date
  const [date, setDate] = useState(null);
  const [displayEndDate, setDisplayEndDate] = useState(null);
  const [dateFocused, setDateFocused] = useState(false);

  const [SelectedStartDate, setSelectedStartDate] = useState(null);
  const [endDate, setEndDate] = useState(
    getLastDateOfCurrentMonthPayloadFormat()
  );

  const [SelectedEndDate, setSelectedEndDate] = useState(null);

  const [startDateFormat, setstartDateFormat] = useState(
    getFirstDateOfCurrentMonthPayloadFormate()
  );

  const datePickerOnChange = (newValue) => {
    setSelectedStartDate(newValue);

    const dateStr2 = newValue.toDate
      ? newValue.toDate().toLocaleDateString("en-GB", {
          year: "numeric",
          month: "long",
          day: "2-digit",
        })
      : newValue.format("DD-MMMM-YYYY");
    let dateContainer = String(dateStr2).split(" ");
    var year2 = dateContainer[2];
    var month2 = dateContainer[1];
    var day2 = dateContainer[0];
    var formattedDate2 = day2 + "-" + month2 + "-" + year2;
    setDate(formattedDate2);

    // Update startDateFormat for API call
    setstartDateFormat(newValue.format("YYYY-MM-DD"));
    setStartDateOpen(false);
    setEndDateOpen(true);
  };
  const datePickerOnChangeEnd = (newValue) => {
    setSelectedEndDate(newValue);

    const dateStr2 = newValue.toDate
      ? newValue.toDate().toLocaleDateString("en-GB", {
          year: "numeric",
          month: "long",
          day: "2-digit",
        })
      : newValue.format("DD-MMMM-YYYY");
    let dateContainer = String(dateStr2).split(" ");
    var year2 = dateContainer[2];
    var month2 = dateContainer[1];
    var day2 = dateContainer[0];
    var formattedDate2 = day2 + "-" + month2 + "-" + year2;
    setDisplayEndDate(formattedDate2);

    // Update endDate for API call
    setEndDate(newValue.format("YYYY-MM-DD"));
    setEndDateOpen(false);
  };
  const cardKet = {
    persnoalInf: [
      {
        key: "appointmentId",
        label: "Appointment Id",
        color: "#bb4a9b",
      },
      {
        key: "customerName",
        label: "Customer Name",
        color: "#bb4a9b",
      },
      {
        key: "services",
        // color: "black",
        label: "services",
        addedKey: { key: "service" },
        addedKey: { key: "service" },
      },

      {
        key: "mobileNumber",
        // color: "black",
        label: "Mobile Number",
      },
      {
        key: "date",
        // color: "black",
        label: "Date ",
        splitF: { target: "T", index: 0 },
      },
      // {
      //   keys: ["paymentPercentage", "salaryorPercentage"],
      //   color: "#3695B6",
      //   label: "Payment Percentage",
      // },
    ],
    educationalDetail: [
      {
        key: "courseName",
        label: "Course Name",
      },
      {
        key: "courseDetails",
        label: "Component Name",
      },
      {
        key: "durationInYear",
        label: "Duration In Year",
      },
      {
        key: "percentage",
        label: "Percentage",
      },

      {
        key: "grade",
        label: "grade",
      },
      {
        key: "institute",
        label: "institute",
      },
      {
        key: "university",
        label: "university",
      },
    ],

    incentrive: [
      {
        key: "incentiveName",
        label: "Incentive Name",
      },
      {
        key: "minimumValue",
        label: "Minimum Value",
      },
      {
        key: "maximumValue",
        label: "Maximum Value",
      },

      {
        key: "percentage",
        label: "percentage",
      },
    ],
    Deductions: [
      {
        key: "componentName",
        label: "Component Name",
      },
      {
        key: "amount",
        label: "Amount",
      },

      {
        key: "percentage",
        label: "Percentage",
      },
    ],
  };

  function addLeadingZero(value) {
    return value < 10 ? "0" + value : value;
  }

  const displayDateFormat = () => {
    var currentDate = new Date();
    let dateContainer = String(currentDate).split(" ");

    var year = dateContainer[2];
    var month = dateContainer[1];

    var day = dateContainer[3];

    var formattedDate =
      year + "-" + addLeadingZero(month) + "-" + addLeadingZero(day);

    return formattedDate;
  };
  const [appoinmentReports, setappoinmentReports] = useState({
    totalRecords: "",
    appoinmentReports: [],
  });
  const [filter, setFilter] = useState("");
  const [startDateOpen, setStartDateOpen] = useState(false);
  const [endDateOpen, setEndDateOpen] = useState(false);

  const getYear = (date) => {
    let ar = date.split("-");
    return ar[ar.length - 1];
  };
  // const [date, setDate] = useState(getYear(displayDateFormat()));

  const [startDate, setStartDate] = useState(new Date());
  const [search, setSearch] = useState("");
  const datePickerRef = useRef();

  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  const getData = async (param) => {
    await getAppoinment(
      {
        ...param,
        page: 1,
        pageSize: 1000,
      },
      (res) => {
        setappoinmentReports({
          ...appoinmentReports,
          appoinmentReports: res?.data?.list,
          totalRecords: res?.data?.totalRecords,
        });
      }
    );
  };

  const downloadXLSXFile = async (param) => {
    try {
      // const response = await axios.post(
      //   "user/api/v1/Salon/GetCustomerAppointmentsV2Xlsx",
      //   param,
      //   {
      //     responseType: "blob",
      //   }
      // );

      const response = await getAppointmentXlsx(param, {
        responseType: "blob",
      });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "file.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading XLSX file:", error);
    }
  };

  useEffect(() => {
    console.log("datE ", date);
    getData({
      // year: Number(payloadDateFormat().split("-")[0]),
      fromDate: startDateFormat,
      toDate: endDate,
      filter: "status",
      search: !!filter ? filter : "",
    });
    console.log("appoinmentReports ", appoinmentReports);
  }, [startDateFormat, endDate, filter]);
  useEffect(() => {
    getData({
      // year: Number(payloadDateFormat().split("-")[0]),
      fromDate: startDateFormat,
      toDate: endDate,
    });
  }, []);
  return (
    <>
      <Box
        px={{ sm: 4, xs: 2 }}
        pb={4}
        container
        sx={{
          paddingTop: "15px",
          backgroundColor: "#E3E3FF",
          fontFamily: "'Montserrat', sans-serif",
        }}
      >
        <Heading name="Appointment Report" />

        {/* <Grid
          item
          xs={12}
          sx={{
            background:
              "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
            padding: "10px",
            mt: "10px",
            borderRadius: "5px",
            color: "#01008B", // optional text color
            textAlign: "left",
            marginBottom: "20px",
            fontFamily: "'Montserrat', sans-serif",
            fontSize: "20px",
            fontWeight: 500,
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontSize: { xs: "12px", sm: "13px", md: "15px" } }}
          >
            Appointment Report
          </Typography>
        </Grid> */}
        <Grid
          container
          // xs={12}
          sx={{
            display: "flex",
            alignItems: "center",
            // height: "50px",
            gap: { md: 2, xs: 0, lg: 3 },
          }}
        >
          <Grid item xs={12} md={8} lg={9}>
            <TextField
              label="Date :"
              size="small"
              value={
                SelectedStartDate && SelectedEndDate
                  ? `${SelectedStartDate.format(
                      "DD-MM-YYYY",
                    )} to ${SelectedEndDate.format("DD-MM-YYYY")}`
                  : SelectedStartDate
                    ? `${SelectedStartDate.format("DD-MM-YYYY")}`
                    : ""
              }
              id="datepickerfield"
              placeholder="Select date range"
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <CalendarMonthIcon
                    sx={{
                      cursor: "pointer",
                      mr: 1,
                    }}
                    onClick={() => setStartDateOpen(true)} // trigger open
                  />
                ),
                sx: {
                  background: "#fff",
                  borderRadius: 1,
                  cursor: "pointer",
                  fontFamily: "'Montserrat', sans-serif",
                  fontWeight: 500,
                },
              }}
              onClick={() => setStartDateOpen(true)} // trigger open
              sx={{
                width: "100%",
                height: "50px",
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    border: "none",
                  },
                },
              }}
            />

            <Box sx={{ position: "relative" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  open={startDateOpen}
                  onOpen={() => setStartDateOpen(true)}
                  onClose={() => setStartDateOpen(false)}
                  value={SelectedStartDate}
                  onChange={(val) => {
                    datePickerOnChange(val);
                  }}
                  maxDate={SelectedEndDate || undefined}
                  slotProps={{
                    popper: {
                      placement: "bottom-start",
                      anchorEl: document.querySelector("#datepickerfield"),
                      sx: { zIndex: 1500 },
                    },
                    textField: { style: { display: "none" } },
                  }}
                />
              </LocalizationProvider>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  open={endDateOpen}
                  onOpen={() => setEndDateOpen(true)}
                  onClose={() => setEndDateOpen(false)}
                  value={SelectedEndDate}
                  onChange={(val) => {
                    datePickerOnChangeEnd(val);
                  }}
                  minDate={SelectedStartDate || undefined}
                  slotProps={{
                    popper: {
                      placement: "bottom-start",
                      anchorEl: document.querySelector("#datepickerfield"),
                      sx: { zIndex: 1500 },
                    },
                    textField: { style: { display: "none" } },
                  }}
                />
              </LocalizationProvider>
            </Box>
          </Grid>

          <Grid
            item
            md={3}
            xs={12}
            lg={2}
            mb={1}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              variant="contained"
              fullWidth
              onClick={() => {
                downloadXLSXFile({
                  fromDate: startDateFormat,
                  toDate: endDate,
                  filter: "status",
                  search: !!filter ? filter : "",
                  page: 1,
                  pageSize: 1000,
                });
              }}
              // sx={{ height: "40px", backgroundColor: "#14008B" }}
              endIcon={<FileDownloadIcon />}
            >
              Download
            </Button>
          </Grid>
        </Grid>

        <Grid
          item
          xs={12}
          spacing={3}
          sx={{
            overflowX: "auto",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "5px",
            flexWrap: "nowrap",
          }}
        >
          <Grid
            container
            spacing={3}
            // mt={1}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            {["Completed", "Cancelled"]?.map((ele, index) => (
              <Grid item xs={6} sm={3}>
                <Button
                  key={index}
                  variant="outlined"
                  onClick={() => {
                    setFilter(ele);
                  }}
                  fullWidth
                  sx={{
                    height: "40px",
                    width: "100%",
                    backgroundColor: ele === filter ? "#9B9BF3" : "white",
                    border: "1px solid #14008B",
                    borderRadius: "10px",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },

                    padding: "0px",
                    "&:hover": {
                      backgroundColor: "#9B9BF3",
                    },
                  }}
                >
                  {ele}
                </Button>
              </Grid>
            ))}
          </Grid>
        </Grid>

        <Grid xs={12} mt={2} mr={1}>
          <Box
            sx={{
              backgroundColor: "white",
              width: "100%",
              padding: { xs: "0px", sm: "10px" },
              borderRadius: "12px",
            }}
          >
            <Grid container sx={{ p: "10px", mt: 2, background: "white" }}>
              <Grid item xs={12}>
                <Grid
                  container
                  spacing={1}
                  sx={{ borderBottom: "1px solid #1E1E1E" }}
                >
                  <Grid item xs={2}>
                    <Typography
                      // fontWeight="bold"
                      color="primary"
                      sx={{
                        paddingLeft: {
                          sm: "10px",
                          md: "10px",
                          lg: "50px",
                          xs: "1px",
                        },
                        fontWeight: 500,
                        fontSize: { xs: "10px", sm: "13px", md: "15px" },
                      }}
                    >
                      Appointment Id
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography
                      align="center"
                      // fontWeight="bold"
                      color="primary"
                      sx={{
                        paddingLeft: {
                          sm: "10px",
                          md: "10px",
                          lg: "50px",
                          xs: "30px",
                        },
                        fontWeight: 500,
                        fontSize: { xs: "10px", sm: "13px", md: "15px" },
                      }}
                    >
                      Customer Name
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Typography
                      align="center"
                      // fontWeight="bold"
                      color="primary"
                      sx={{
                        paddingLeft: {
                          sm: "10px",
                          md: "10px",
                          lg: "50px",
                          xs: "13px",
                        },
                        fontWeight: 500,
                        fontSize: { xs: "10px", sm: "13px", md: "15px" },
                      }}
                    >
                      Mobile
                    </Typography>
                  </Grid>
                  <Grid item xs={5}>
                    <Typography
                      align="center"
                      // fontWeight="bold"
                      color="primary"
                      sx={{
                        fontWeight: 500,
                        fontSize: { xs: "10px", sm: "13px", md: "15px" },
                      }}
                    >
                      Services
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                sx={{ height: "60vh", overflow: "auto", marginTop: "10px" }}
              >
                {appoinmentReports?.appoinmentReports?.map((item, i) => {
                  return (
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      // lg={6}
                      key={"payamentRecpt" + i}
                      sx={{ p: "0px" }}
                    >
                      <Card
                        sx={{
                          width: "96%",
                          mt: "12px",
                          cursor: "pointer",
                          backgroundColor: "#E8E8FF",
                          "& .MuiCardContent-root": { p: "0rem" },
                          borderRadius: "14px",
                          padding: "10px ",
                          // paddingLeft: "30px",
                          boxShadow: "none",
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        }}
                      >
                        <CardContent sx={{ padding: "0rem 0.1rem !important" }}>
                          <Grid container>
                            <Grid item xs={2}>
                              <Typography
                                color="primary"
                                sx={{
                                  // overflow: "Hidden",
                                  // display: "-webkit-box",
                                  // fontWeight: 500,
                                  // "-webkit-line-clamp": "1",
                                  // "-webkit-box-orient": "vertical",
                                  // fontWeight: 600,
                                  color: "black",
                                  padding: "0px 0px",
                                  borderRadius: "10px",
                                  fontSize: {
                                    xs: "10px",
                                    sm: "13px",
                                    md: "15px",
                                  },
                                  pl: { xs: 0, sm: 0, md: 0, lg: 4 },
                                }}
                              >
                                {item?.appointmentId}
                              </Typography>
                            </Grid>
                            <Grid item xs={3}>
                              <Typography
                                color="primary"
                                sx={{
                                  fontSize: {
                                    xs: "10px",
                                    sm: "13px",
                                    md: "15px",
                                  },
                                  // overflow: "Hidden",
                                  // display: "-webkit-box",
                                  // textAlign: "left",
                                  // fontWeight: 500,
                                  // "-webkit-line-clamp": "1",
                                  // "-webkit-box-orient": "vertical",
                                  // fontWeight: 600,
                                  whiteSpace: "normal",
                                  color: "black",
                                  padding: "0px 4px",
                                  pl: { xs: 4, sm: 4, md: 4, lg: 12 },

                                  borderRadius: "10px",
                                }}
                              >
                                {item?.customerName}
                              </Typography>
                            </Grid>

                            <Grid item xs={2}>
                              <Typography
                                color="primary"
                                sx={{
                                  fontSize: {
                                    xs: "10px",
                                    sm: "13px",
                                    md: "15px",
                                  },
                                  // overflow: "Hidden",
                                  // display: "-webkit-box",
                                  // textAlign: "center",
                                  // fontWeight: 500,
                                  // "-webkit-line-clamp": "1",
                                  // "-webkit-box-orient": "vertical",
                                  // fontWeight: 600,
                                  color: "black",
                                  padding: "0px 10px",
                                  borderRadius: "10px",
                                  pl: { xs: 0, sm: 2, md: 4, lg: 12 },
                                }}
                              >
                                {item?.mobileNumber}
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              xs={5}
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                color="dark"
                                sx={{
                                  // textOverflow: "ellipsis",
                                  fontWeight: 500,
                                  textAlign: "left",
                                  width: "100%", // ensures full width
                                  display: "block",
                                  fontSize: {
                                    xs: "10px",
                                    sm: "13px",
                                    md: "15px",
                                  },
                                  pl: { xs: 4, sm: 10, md: 12, lg: 18 },
                                }}
                              >
                                {item?.services?.map((service, index) => (
                                  <span
                                    style={{
                                      textAlign: "left",
                                    }}
                                    key={index}
                                  >
                                    {service.service}
                                    {index < item.services.length - 1
                                      ? ", "
                                      : ""}
                                  </span>
                                ))}
                              </Typography>
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
          </Box>
          {/* <Divider
            sx={{
              width: "100%",
              mt: 2,
              background: (theme) => theme.palette.primary.main,
            }}
          /> */}
          {/* 
          <Grid container>
            <Grid container sx={{ maxHeight: "67vh", overflow: "auto" }}>
              {appoinmentReports?.appoinmentReports?.map((item, i) => {
                return (
                  <Grid item xs={4} key={i}>
                    <CardPayment
                      item={item}
                      setOpen={(data) => { }}
                      setModalData={(dat) => {
                        console.log("upupupupup ", dat);
                        let obj = {};
                        Object.keys(dat).map((key, index) => {
                          if (dat[key] && dat[key] != "null") {
                            obj[key] = dat[key];
                          } else {
                            obj[key] = "";
                          }
                        });
                        console.log("objobjobjobj", obj);

                        // setModalData({...obj,
                        // });
                        // setModalData(item);
                        // setOpen(true);

                        // setModalDataT(obj);
                        // setOpenT(true);
                      }}
                      cardKet={cardKet?.persnoalInf}
                    />
                  </Grid>
                );
              })}
            </Grid>
          </Grid> */}
        </Grid>
      </Box>
      {/* </Box> */}
      {/* </Drawer> */}
    </>
  );
};

export default AppoinmentReport;
